import { evaluate } from "mathjs"

export default class expressionValidation {
	static isValidMathExpression (expression: string) {
		if (!expression) return false

		if (expression.trim().length < 1) return false

		// Indicates two fields side by side
		if (expression.includes("}{")) return false

		// Match any fields that need to be replaced for the purposes of the validation
		var matches = expression.match(/(\{.+?\})/g)
		if (matches != null && matches.length > 0) {
			matches.forEach(match => {
				// Replace field with value 1
				expression = expression.replace(match, "1")
			})
		}

		// Matches any character that is not a digit, mathematical operator, dot, or whitespace as invalid
		if (expression.match(/[^\d\s+\-*/.()%^!]/)) return false

		try {
			var evaluated = evaluate(expression)
			// If calculation is Invalid, e.g dividing by zero
			if (evaluated === Infinity) {
				return false
			}
			return true
		} catch (e) {
			return false
		}
	}
}
